/* ==========================================================================
   RYMBU "Montage aan huis" — opt-in montage per toestel
   --------------------------------------------------------------------------
   1. Op de productpagina staat een checkbox + zonekeuze (snippets/ry-montage.liquid).
      Vinkt de klant die aan en klikt hij op "In winkelwagen", dan voegen wij
      in ÉÉN request het toestel + het montage-product toe — en, als de klant
      "verder dan 50 km" koos, ook de verre-levertoeslag (extra regel met dezelfde
      toestelkoppeling + vlag _montage_toeslag). De montageregel krijgt:
        - een zichtbare property "Voor toestel" = de toestelnaam (zo weet het
          RYMBU-team én Odoo bij welk toestel de montage hoort);
        - een verborgen property "_montage_voor" = het variant-id van het
          toestel (waarmee wij de regel koppelen en opruimen).
      Aantal montages = aantal toestellen -> per toestel afgerekend, en per
      toestel een aparte orderregel in Odoo (via de Emipro-connector).

   2. Daarna houden wij de winkelwagen netjes:
        - toestel volledig uit de cart  -> bijhorende montageregel verdwijnt;
        - minder toestellen dan montages -> montage-aantal wordt teruggebracht.
      We voegen NOOIT vanzelf montage toe (dat kan enkel via de checkbox), dus
      de klant wordt nooit verrast met een kost die hij niet koos.

   Het montage-product zelf koppel je in Thema-instellingen (settings.montage_product)
   en zet je per toestel-template aan met "Toon montage-optie".
   ========================================================================== */
(function () {
  'use strict';

  var KEY = '_montage_voor';       // verborgen property: variant-id van het toestel
  var LABEL = 'Voor toestel';      // zichtbare property: naam van het toestel
  var TKEY = '_montage_toeslag';   // verborgen vlag op de verre-levertoeslag-regel
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?([?#]|$)/;
  var DEBOUNCE_MS = 350;

  var internalCall = false;   // markeert onze eigen cart-calls (niet op reageren)
  var reconciling = false;
  var reQueued = false;
  var timer = null;

  function routes() {
    var r = window.routes || {};
    return {
      cart: r.cart_url || '/cart',
      add: r.cart_add_url || '/cart/add',
      change: r.cart_change_url || '/cart/change'
    };
  }

  function internalFetch(url, cfg) {
    internalCall = true;
    try { return window.fetch(url, cfg); }
    finally { internalCall = false; }
  }

  function fetchCart() {
    return window.fetch(routes().cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ---------- de add-to-cart onderscheppen (alleen als montage aangevinkt) -- */

  // Vind het <montage-option> dat bij DIT product-formulier hoort. We beperken
  // ons bewust tot hetzelfde buy-buttons-blok als de hoofd-koopknop, zodat het
  // complementary-product-formulier (aanbevolen producten) nooit montage triggert.
  function montageForForm(form) {
    var pf = form.closest('product-form');
    if (!pf || pf.classList.contains('complementary-product-form')) return null;
    var container = pf.parentElement;
    return container ? container.querySelector('montage-option') : null;
  }

  function setLoading(btn, on) {
    if (!btn) return;
    var spinner = btn.querySelector('.loading-overlay__spinner');
    if (on) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function showError(pf, message) {
    if (!pf) return;
    var wrap = pf.querySelector('.product-form__error-message-wrapper');
    var msg = pf.querySelector('.product-form__error-message');
    if (msg) msg.textContent = message || 'Er ging iets mis. Probeer het opnieuw.';
    if (wrap) wrap.removeAttribute('hidden');
  }

  function onSubmitCapture(evt) {
    var form = evt.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

    var mo = montageForForm(form);
    if (!mo) return;
    var cb = mo.querySelector('.ry-montage__checkbox');
    if (!cb || !cb.checked) return;   // montage niet gekozen -> gewone flow, niets doen

    var idInput = form.querySelector('[name="id"]');
    var deviceVar = idInput ? Number(idInput.value) : 0;
    var montageVar = Number(mo.getAttribute('data-montage-variant'));
    if (!deviceVar || !montageVar) return;   // config onvolledig -> laat het thema het toestel gewoon toevoegen

    var qtyEl = form.elements ? form.elements['quantity'] : null;
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    if (qty < 1) qty = 1;

    // Zone: "verder dan 50 km" -> verre-levertoeslag mee toevoegen (als geconfigureerd).
    var toeslagVar = Number(mo.getAttribute('data-toeslag-variant')) || 0;
    var zoneEl = mo.querySelector('.ry-montage__zone-input:checked');
    var far = !!(zoneEl && zoneEl.value === 'far');
    var deviceTitle = mo.getAttribute('data-device-title') || '';

    // Vanaf hier nemen WIJ de add over.
    evt.preventDefault();
    evt.stopImmediatePropagation();

    var pf = form.closest('product-form');
    var btn = pf ? pf.querySelector('[type="submit"]') : form.querySelector('[type="submit"]');
    setLoading(btn, true);

    var props = {};
    props[LABEL] = deviceTitle;
    props[KEY] = String(deviceVar);

    var items = [
      { id: deviceVar, quantity: qty },
      { id: montageVar, quantity: qty, properties: props }
    ];

    if (far && toeslagVar) {
      var tprops = {};
      tprops[LABEL] = deviceTitle;
      tprops[KEY] = String(deviceVar);   // zelfde koppeling -> mee opgeruimd/gecapt met het toestel
      tprops[TKEY] = '1';
      items.push({ id: toeslagVar, quantity: qty, properties: tprops });
    }

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    function sectionsBody(list) {
      var b = { items: list };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        b.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        b.sections_url = window.location.pathname;
      }
      return b;
    }

    function post(list) {
      return internalFetch(routes().add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(sectionsBody(list))
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
    }

    function applyResult(res) {
      if (cart && typeof cart.renderContents === 'function') {
        // Een add met een items[]-array levert een respons ZONDER top-level key/id.
        // cart-notification.renderContents heeft die key nodig (anders zoekt hij
        // "cart-notification-product-undefined" -> crash). Zet 'm op de TOESTEL-regel
        // zodat de "toegevoegd"-popup het toestel toont; montage/toeslag staan mee
        // in de cart. cart-drawer gebruikt de key niet, dus daar is dit onschadelijk.
        var b = res.body;
        if (b && b.key == null && b.items && b.items.length) {
          var dev = null;
          for (var i = 0; i < b.items.length; i++) {
            var it = b.items[i];
            if (Number(it.id) === deviceVar || Number(it.variant_id) === deviceVar) { dev = it; break; }
          }
          dev = dev || b.items[0];
          b.key = dev.key;
          if (b.id == null) b.id = dev.id;
        }
        cart.renderContents(b);
      } else {
        window.location = routes().cart;
      }
    }

    post(items).then(function (res) {
      if (res.ok) { applyResult(res); return; }
      // Gecombineerde add mislukte (zeldzaam) — voeg dan minstens het toestel toe
      // zodat de klant niet geblokkeerd raakt; montage laten we vallen.
      console.warn('[ry-montage] toestel + montage mislukt, val terug op enkel toestel:',
        res.body && (res.body.description || res.body.message));
      return post([{ id: deviceVar, quantity: qty }]).then(function (res2) {
        if (res2.ok) applyResult(res2);
        else showError(pf, res2.body && (res2.body.description || res2.body.message));
      });
    }).catch(function (e) {
      console.warn('[ry-montage] toevoegen mislukt:', e);
      showError(pf, null);
    }).then(function () {
      setLoading(btn, false);
    });
  }

  /* ---------- opruimen/synchroniseren van montageregels -------------------- */

  function changeLine(key, quantity) {
    return internalFetch(routes().change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  function reconcile() {
    if (reconciling) { reQueued = true; return; }
    reconciling = true;

    fetchCart().then(function (cart) {
      // Aantal toestellen per variant (montageregels niet meegeteld).
      var deviceQty = {};
      cart.items.forEach(function (it) {
        var isMontage = it.properties && it.properties[KEY];
        if (isMontage) return;
        deviceQty[it.variant_id] = (deviceQty[it.variant_id] || 0) + it.quantity;
      });

      var ops = [];
      cart.items.forEach(function (it) {
        var boundTo = it.properties && it.properties[KEY];
        if (!boundTo) return;
        var have = deviceQty[Number(boundTo)] || 0;
        if (have === 0) {
          ops.push({ key: it.key, quantity: 0 });          // toestel weg -> montage weg
        } else if (it.quantity > have) {
          ops.push({ key: it.key, quantity: have });        // minder toestellen -> montage cappen
        }
      });

      if (!ops.length) { done(); return; }

      var chain = Promise.resolve();
      ops.forEach(function (op) {
        chain = chain.then(function () { return changeLine(op.key, op.quantity); });
      });
      chain.then(function () { return renderSections(); }).then(done, done);
    }).catch(function () { done(); });

    function done() {
      reconciling = false;
      if (reQueued) { reQueued = false; schedule(); }
    }
  }

  function schedule() {
    if (reconciling) { reQueued = true; return; }
    clearTimeout(timer);
    timer = setTimeout(reconcile, DEBOUNCE_MS);
  }

  /* ---------- winkelwagen-secties her-renderen ----------------------------- */
  // Compacte variant van de aanpak in ry-gratis-deal.js: alleen nodig wanneer de
  // klant de drawer/cart-pagina open heeft terwijl wij een montageregel opruimen.

  function sectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = selector ? doc.querySelector(selector) : doc.body;
    return el ? el.innerHTML : null;
  }

  function renderSections() {
    var jobs = [];
    var drawer = document.querySelector('cart-drawer');
    if (drawer && document.getElementById('CartDrawer')) {
      jobs.push({ id: 'cart-drawer', apply: function (html) {
        var content = sectionInnerHTML(html, '#CartDrawer');
        if (content === null) return;
        document.getElementById('CartDrawer').innerHTML = content;
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
      } });
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      jobs.push({ id: 'cart-icon-bubble', apply: function (html) {
        var content = sectionInnerHTML(html, '.shopify-section');
        if (content === null) return;
        (bubble.querySelector('.shopify-section') || bubble).innerHTML = content;
      } });
    }
    var mci = document.getElementById('main-cart-items');
    if (mci && mci.dataset.id) {
      jobs.push({ id: mci.dataset.id, apply: function (html) {
        var content = sectionInnerHTML(html, '.js-contents');
        var target = mci.querySelector('.js-contents');
        if (content !== null && target) target.innerHTML = content;
      } });
    }
    var mcf = document.getElementById('main-cart-footer');
    if (mcf && mcf.dataset.id) {
      jobs.push({ id: mcf.dataset.id, apply: function (html) {
        var content = sectionInnerHTML(html, '.js-contents');
        var target = mcf.querySelector('.js-contents');
        if (content !== null && target) target.innerHTML = content;
      } });
    }
    if (!jobs.length) return Promise.resolve();

    var ids = [];
    jobs.forEach(function (j) { if (ids.indexOf(j.id) === -1) ids.push(j.id); });

    return fetchCart().then(function (cart) {
      var url = routes().cart + '?sections=' + encodeURIComponent(ids.join(','));
      return window.fetch(url).then(function (r) { return r.json(); }).then(function (sections) {
        jobs.forEach(function (j) {
          if (sections && sections[j.id]) {
            try { j.apply(sections[j.id]); } catch (e) { /* sectie-render faalde, negeren */ }
          }
        });
        var isEmpty = cart.item_count === 0;
        if (drawer) drawer.classList.toggle('is-empty', isEmpty);
        var cartItemsEl = document.querySelector('cart-items');
        if (cartItemsEl) cartItemsEl.classList.toggle('is-empty', isEmpty);
        if (mcf) mcf.classList.toggle('is-empty', isEmpty);
      });
    });
  }

  /* ---------- cart-mutaties van thema/apps opvangen ------------------------ */

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = '';
    try {
      url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    } catch (e) { /* ignore */ }
    var p = origFetch.apply(this, arguments);
    if (!internalCall && CART_MUTATION_RE.test(url)) {
      p.then(function () { schedule(); }, function () { /* ignore */ });
    }
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (typeof url === 'string' && CART_MUTATION_RE.test(url)) {
        this.addEventListener('load', function () { schedule(); });
      }
    } catch (e) { /* ignore */ }
    return origOpen.apply(this, arguments);
  };

  /* ---------- init --------------------------------------------------------- */

  // Onderschep formulierverzendingen in de capture-fase op document-niveau: zo
  // draaien wij vóór product-form.js en kunnen we de add gecontroleerd overnemen
  // (of met rust laten wanneer montage niet aangevinkt is).
  document.addEventListener('submit', onSubmitCapture, true);

  // Bij elke paginaweergave één keer opruimen (zelfherstellend, vangt ook
  // wijzigingen uit een andere tab of gemiste events op).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });

  // Handmatig te triggeren voor debugging: window.ryMontageSync()
  window.ryMontageSync = schedule;
})();
